import { useMfaServiceMfaUsersList } from '@organization/api/queries'
import { MFAUser } from '@organization/api/requests'
import { SearchInput, TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { Flex, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import { ConfigMFAFilters, ConfigMFATable } from '../components'

export const ConfigsMFAPage = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  const { triggerSort, getSortedTableColumns } = useSorting<MFAUser>()

  const { data, isLoading } = useMfaServiceMfaUsersList(params)

  return (
    <>
      <TitleSection
        title={t('menu.configs_mfa')}
        count={data?.count}
        isLoading={isLoading}
      >
        <Space>
          <SearchInput placeholder={t('common.search')} />
        </Space>
      </TitleSection>

      <Flex vertical gap={16}>
        <ConfigMFAFilters />

        <ConfigMFATable
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page: number, pageSize: number) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
